import { API_PREFIX, type HttpClient } from "@nasam/kernel";
import type { CatalogRepository } from "../domain";
import { sellableModuleFromDto, sellingPriceToDto } from "./catalogMappers";
import {
  moduleCapacitiesResponseDtoSchema,
  sellableModuleResponseDtoSchema,
  sellableModulesResponseDtoSchema,
  sellingPriceWriteDtoSchema,
} from "./catalogDtos";

const MODULES_PATH = `${API_PREFIX}/modules`;

/**
 * "Http" here still means MSW-backed in dev/test — every call goes through
 * `HttpClient`, is parsed at the DTO boundary, and is intercepted by the
 * handlers in `../testing`.
 */
export function createCatalogHttpRepository(
  http: HttpClient,
): CatalogRepository {
  return {
    async list() {
      const response = await http.get(`${MODULES_PATH}/sellable`);
      return sellableModulesResponseDtoSchema
        .parse(response)
        .data.map(sellableModuleFromDto);
    },

    async listCapacity() {
      const response = await http.get(`${MODULES_PATH}/capacity`);
      return moduleCapacitiesResponseDtoSchema.parse(response).data;
    },

    async updateSellingPrice(id, input) {
      const body = sellingPriceWriteDtoSchema.parse(sellingPriceToDto(input));
      const response = await http.patch(
        `${MODULES_PATH}/${id}/selling-price`,
        body,
      );
      return sellableModuleFromDto(
        sellableModuleResponseDtoSchema.parse(response).data,
      );
    },
  };
}
